import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import './Buttons.scss';
import CustomTooltip from '../../../../components/card/CustomTooltip';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  ariaLabel: '',
  onClick: () => null,
  disabled: false,
};
const ViewButton = (props) => {
  const { ariaLabel, onClick, ...rest } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <CustomTooltip title={ariaLabel} aria-label={ariaLabel}>
      <span>
        <IconButton
          {...rest}
          className='admin-action-icon-button'
          aria-label={ariaLabel}
          onClick={onClick}
        >
          <InfoIcon />
        </IconButton>
      </span>
    </CustomTooltip>
  );
};

export default ViewButton;
